import React from "react";
import PropTypes from "prop-types";

import "stories/layout/Card.css";
import "./SummaryMetricCard.css";

/**
 * Reusable metric tile (label + primary value + optional footer). Use inside grids or dashboards.
 */
const SummaryMetricCard = ({
  label,
  value,
  footer,
  valueTone = "neutral",
  footerTone,
  className,
}) => {
  const resolvedFooterTone = footerTone || valueTone;
  const valueClass =
    valueTone === "positive"
      ? "summary-metric-card__value summary-metric-card__value--positive"
      : valueTone === "negative"
        ? "summary-metric-card__value summary-metric-card__value--negative"
        : "summary-metric-card__value";

  const footerClass =
    resolvedFooterTone === "positive"
      ? "summary-metric-card__footer summary-metric-card__footer--positive"
      : resolvedFooterTone === "negative"
        ? "summary-metric-card__footer summary-metric-card__footer--negative"
        : "summary-metric-card__footer";

  return (
    <div
      className={`summary-metric-card card border-0 shadow-sm-strong h-100 ${className || ""}`.trim()}
    >
      <div className="summary-metric-card__label">{label}</div>
      <div className={valueClass}>{value}</div>
      {footer != null && footer !== "" && <div className={footerClass}>{footer}</div>}
    </div>
  );
};

SummaryMetricCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  footer: PropTypes.node,
  valueTone: PropTypes.oneOf(["neutral", "positive", "negative"]),
  footerTone: PropTypes.oneOf(["neutral", "positive", "negative"]),
  className: PropTypes.string,
};

export default SummaryMetricCard;
